import React, { useState } from 'react'

import ReactTooltip from "react-tooltip";
import { ComposableMap, Geographies, Geography, Graticule, Sphere } from "react-simple-maps";
import { scaleSequential } from "d3-scale";

const geography = process.env.PUBLIC_URL + "/world-countries.json";

function Map({data}) {
  const [tooltip, setTooltip] = useState('');

  if(data === null || data === []) {
    return;
  }

  let result = {};
  let data_size = data.length;

  data.sort((a, b) => { return a.Count - b.Count; });

  for (let i=0; i<data_size; i++) {
    result[data[i].CountryCode] = {'Count': data[i].Count, 'Rank': i};
  }

  return (
    <div className="Map">
      <ComposableMap projectionConfig={{ scale: 147 }} data-tip="" width={900} height={450}>
        <Sphere stroke="#E4E5E6" strokeWidth={0.5} />
        <Graticule stroke="#E4E5E6" strokeWidth={0.5} />
        <Geographies geography={geography} stroke="#29465b" strokeWidth={0.5}>
          {({ geographies }) =>
            geographies.map((geo) => {
              let d = null;
              let code = geo.properties["Alpha-2"];
              let data_size = Object.keys(result).length;

              if(code in result) {
                d = result[code]
              }

              let colorScale = scaleSequential()
                .domain([0, data_size])
                .range(["#fffefa", "#FFC30B"]);

              return (<Geography
                key={geo.rsmKey}
                geography={geo}
                fill={d ? colorScale(d.Rank) : "#F5F4F6"}
                onMouseEnter={() => {
                  if(d) { setTooltip(d.Count); }
                }}
                onMouseLeave={() => {
                  setTooltip('');
                }}
              />)
            })
          }
        </Geographies>
      </ComposableMap>
      <ReactTooltip>{tooltip}</ReactTooltip>
    </div>
  );
}

export default Map;
